import React from "react";
import logo from "../../../assets/logosss.png";
import { P } from "../../../components/Common/Typo/typo";
import Thaihealth from "../../../assets/thaihealth.png";
import { SubCard } from "./Card";
import dayjs from "dayjs";
import "dayjs/locale/th";
import {
  FaBuilding,
  FaArrowDown,
  FaArrowUp,
  FaLightbulb,
  FaSkullCrossbones,
  FaRegTrashAlt,
} from "react-icons/fa";
import { TbAirConditioning, TbFishBone } from "react-icons/tb";
import { AiFillThunderbolt } from "react-icons/ai";

dayjs.locale("th");

const mappingIcon: any = {
  building: <FaBuilding className="w-5 h-5 fill-white" />,
  air_condition: <TbAirConditioning className="w-5 h-5 fill-white" />,
  light: <FaLightbulb className="w-5 h-5 fill-white" />,
  fish_bone: <TbFishBone className="w-5 h-5 fill-white" />,
  skull: <FaSkullCrossbones className="w-5 h-5 fill-white" />,
  thunder: <AiFillThunderbolt className="w-5 h-5 fill-white" />,
  trash: <FaRegTrashAlt className="w-5 h-5 fill-white" />,
};

const CompareCard = ({
  title,
  value,
  percent,
  icon,
  bgColor,
  unit,
  date_type,
  borderColor,
}: any) => {
  return (
    <div
      className="p-2 rounded-lg flex items-center justify-between border"
      style={{ background: bgColor, borderColor: borderColor }}
    >
      <div className="flex items-center gap-2">
        <div className="w-10 h-10 rounded-full flex items-center justify-center p-1 bg-[#000] bg-opacity-30">
          {mappingIcon[icon]}
        </div>
        <div className="text-[#000] font-bold leading-[20px]">
          <p className="text-[16px]">{title}</p>
          <div className="flex items-center gap-1">
            <p className="text-[20px]">
              {value?.toLocaleString(undefined, {
                maximumFractionDigits: 2,
              })}
            </p>
            <p className="text-[20px]">{unit}</p>
          </div>
        </div>
      </div>
      <div className="text-end text-[#000]">
        <div className="flex items-center gap-1 font-bold text-[20px]">
          {percent > 0 ? (
            <FaArrowUp className="fill-[#EF4337]" />
          ) : (
            <FaArrowDown className="fill-[#43A452]" />
          )}
          <p>{percent <= 0 ? "ลดลง" : "เพิ่มขึ้น"}</p>
          <p>{Math.abs(percent)} %</p>
        </div>

        {date_type === "year" ? <p>จากปีที่แล้ว</p> : <p>จากเดือนที่แล้ว</p>}
      </div>
    </div>
  );
};

const MiddleSection = ({ targetCardData, type }: any) => {
  const today = dayjs();
  const startOfYear = dayjs().startOf("year"); // Get January 1st of this year
  const daysPassed = today.diff(startOfYear, "day");
  return (
    <div>
      <P fontSize="24px" fontWeight="700" color="#1D1D1C">
        {type === "energy"
          ? "การเปรียบเทียบการใช้พลังงาน"
          : type === "waste"
          ? "การเปรียบเทียบขยะที่เกิดขึ้น"
          : "การเปรียบเทียบการปล่อยคาร์บอน"}
      </P>
      {/* <div className="flex items-center gap-1">
        <p>{today.add(543, "year").format("D MMMM YYYY")}</p>
        <p>
          ({daysPassed} วัน จากวันที่ {startOfYear.format("D MMMM YYYY")})
        </p>
      </div> */}
      <div className="flex flex-col gap-4 mt-2">
        {targetCardData?.map((data: any) => (
          <CompareCard
            title={data.title}
            value={data.value}
            percent={data.percent}
            icon={data.icon}
            bgColor={data.bgColor}
            borderColor={data.borderColor}
            unit={data.unit}
            date_type={data.date_type}
          />
        ))}
      </div>
    </div>
  );
};

const TargetCard = ({
  targetData,
  iaqCardData,
  meterInterval,
  targetCardData,
  type,
}: any) => {
  return (
    <div className="flex flex-col justify-between rounded-xl border border-[#EDEFF9] shadow-cardborder p-[10px] h-full bg-white">
      <div className="flex flex-col items-center">
        <div className="flex items-center justify-start gap-2 w-full">
          <img src={logo} alt="logo" className="h-[60px]" />
          <div className="flex flex-col">
            <P
              fontSize="32px"
              color="#1D1D1C"
              fontWeight="700"
              className="tracking-[0.014px]"
            >
              อาคารศูนย์เรียนรู้สุขภาวะ
            </P>
            <P
              fontSize="20px"
              color="#1D1D1C"
              fontWeight="700"
              className="tracking-[0.009px] -mt-2"
            >
              สำนักงานกองทุนสนับสนุนการสร้างเสริมสุขภาพ
            </P>
          </div>
        </div>
        <img
          src={Thaihealth}
          alt="Thaihealth"
          className={`w-full rounded-lg ${
            targetData?.length < 4 ? "h-[400px] object-cover" : ""
          }`}
          style={
            targetData?.length >= 4
              ? {}
              : {
                  height: "320px",
                  objectFit: "cover",
                  objectPosition: "10% 10%",
                }
          }
        />
      </div>
      {/* <div>
        <P fontSize="24px" fontWeight="700" color="#1D1D1C">
          เป้าหมายที่สำคัญ
        </P>
        {targetData?.map((data: any) => (
          <div
            className="p-[8px] rounded-[10px] mt-2 border border-[#EDEFF9]"
            style={{ background: "#F8F8F8" }}
          >
            <p className="text-[22px] text-[#063E40] leading-[24px]">
              {data.title}
            </p>
            <div className="grid grid-cols-5 gap-x-2 -mt-[4px] w-full items-center">
              <div className="col-span-4 w-full flex flex-col items-center justify-center">
                <P fontSize="12px" lineHeight="12px" color="#788796">
                  {data?.details?.date_type === "year" ? "ปี" : "เดือน"}{" "}
                  {data?.details?.date_type === "year"
                    ? new Date(data?.details?.last_date * 1000).getFullYear()
                    : new Date(data?.details?.last_date * 1000).toLocaleString(
                        "th-TH",
                        { month: "short", timeZone: "Asia/Bangkok" }
                      )}
                </P>
                <P fontSize="12px" lineHeight="12px" color="#212529">
                  {Number(data?.details?.last_value).toLocaleString()}{" "}
                  {data?.details?.unit}
                </P>
              </div>
              <div />
              <div className="relative col-span-4 h-[9px] border border-[#DDDDDD] flex rounded-[6px] gap-[1px]">
                <div className="grow bg-[#CBF0EF] h-full rounded-l-[6px]" />
                <div className="grow bg-[#E1FFD5] h-full" />
                <div className="grow bg-[#FBDFB2] h-full" />
                <div className="grow bg-[#FFD4D4] h-full rounded-r-[6px]" />
                <div className="absolute top-[-6px] left-[50%] w-[2px] h-[15px] bg-[#f30e0e] " />
                <div
                  className="absolute top-2 w-0 h-0 border-l-[5px] border-l-transparent border-r-[5px] border-r-transparent border-b-[6px] border-b-[#6D6666]"
                  style={{ left: `${data.percent / 2 + 50}%` }}
                />
              </div>
              <P fontSize="18px" color="#000">
                {data.percent < 0 ? "ลดลง" : "เพิ่มขึ้น"}{" "}
                {Math.abs(data.percent)}%
              </P>
              <div className="col-span-4 w-full flex flex-col items-center justify-center">
                <P
                  fontSize="12px"
                  lineHeight="12px"
                  color="#788796"
                  style={{ marginLeft: `${data.percent}%` }}
                >
                  {data?.details?.date_type === "year" ? "ปี" : "เดือน"}{" "}
                  {data?.details?.date_type === "year"
                    ? new Date(data?.details?.current_date * 1000).getFullYear()
                    : new Date(
                        data?.details?.current_date * 1000
                      ).toLocaleString("th-TH", {
                        month: "short",
                        timeZone: "Asia/Bangkok",
                      })}
                </P>
                <P
                  fontSize="12px"
                  lineHeight="12px"
                  color="#212529"
                  style={{ marginLeft: `${data.percent}%` }}
                >
                  {Number(data?.details?.current_value).toLocaleString()}{" "}
                  {data?.details?.unit}
                </P>
              </div>
            </div>
          </div>
        ))}
      </div> */}
      <MiddleSection targetCardData={targetCardData} type={type} />
      <div className="flex gap-[6px]">
        {iaqCardData?.map((data: any) => (
          <SubCard
            title={data.title}
            value={data.value}
            status={data.status}
            unit={data.unit}
            interval={meterInterval?.[data.key]}
          />
        ))}
      </div>
    </div>
  );
};

export default TargetCard;